// Service status configuration
export const SERVICE_STATUS = {
  octopusSync: true
};

// Helper function to determine overall system status
export const getOverallStatus = () => {
  return SERVICE_STATUS.octopusSync;
};

// Helper function to get status text
export const getStatusText = () => {
  return getOverallStatus() ? 'All Services Online' : 'System Maintenance';
};
